module.exports = __webpack_public_path__ + "media/images/footer/impact-white-e6b090f38a1c664bae89a9920d024d29.png";